import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

export const considerUninitializedSocketDisconnected: GlobalStateCommandFactory =
  (cmdContext) => () => {
    if (cmdContext.getState().socketState === 'UNINITIALIZED') {
      cmdContext.updateState((draft) => {
        draft.socketState = 'DISCONNECTED';
      });
    }
  };
